export class FetchMicaProductPageLength {
  static readonly type = '[number] Fetch All';

  constructor(public payload: number) {
  }
}
